let publicFun = {
  install(Vue) {
    Vue.prototype.publicFun = {
      initPhoneWidth: function () {
        // await (function (doc, win) {
        const win = window
        const doc = document
        let docEl = win.document.documentElement;
        let resizeEvt = "orientationchange" in window ? "orientationchange" : "resize";
        let refreshRem = function () {
          let clientWidth = win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
          if (!clientWidth) return;
          let fz;
          let width = clientWidth;
          // fz = (16 * width) / 375;
          fz = width / 320 * 10
          docEl.style.fontSize = fz + "px";
        };


        if (!doc.addEventListener) return;
        win.addEventListener(resizeEvt, refreshRem, false);
        doc.addEventListener("DOMContentLoaded", refreshRem, false);
        refreshRem();
        // })(document, window);
      },
      trimAll(string) {
        return (string = String(string)).replace(/\s*/g, '');
      },
      rebuildTime: function (time, type) {
        if (!time) return '-'
        const date = new Date(time),
          Y = date.getFullYear(),
          M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1),
          D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()),
          h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()),
          m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
        // s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        if (type === 1) {
          const buildTime = this.fnTime(time, h, m)
          if (buildTime) {
            return buildTime
          } else {
            return String(Y).concat('-', M, '-', D, ' ', h, ':', m)
          }
        } else if (type === 2) {
          return String(Y).concat('/', M, '/', D, ' ', h, ':', m)
        } else if (type === 3) {
          return String(Y).concat('-', M, '-', D, ' ', h, ':', m)
        } else if (type === 4) {
          return String(Y).concat('-', M, '-', D)
        }
        return String(Y).concat(M, D)
      },
      fnTime: function (time, h, m) {
        let ptime = new Date(time).getTime()
        const twentyFourHours = 24 * 60 * 60 * 1000;
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const today = `${year}-${month}-${day}`;
        const todayTime = new Date(today).getTime();
        const yesterdayTime = new Date(todayTime - twentyFourHours).getTime();
        const tomorrow = new Date(todayTime + twentyFourHours).getTime()
        const afteTomorrow = new Date(tomorrow + twentyFourHours).getTime()
        if (ptime >= todayTime && tomorrow > ptime) {
          return '今天 '.concat(h, ':', m);
        } else if (ptime < todayTime && yesterdayTime <= ptime) {
          return '昨天 '.concat(h, ':', m);
        } else if (ptime > tomorrow && afteTomorrow >= ptime) {
          return '明天 '.concat(h, ':', m);
        } else {
          return false;
        }
      },
      getFileSize: function (size, fixed) {
        if (size === 0) {
          return size + 'B'
        }
        if (!size || size === -1) {
          return '-'
        }
        const currentFixed = fixed || 2
        if (size < 1024) {
          return size + 'B'
        } else if (size < 1048576) {   //1024 * 1024
          return (size / 1024).toFixed(currentFixed) + 'K'
        } else if (size < 1073741824) {   //1024 * 1024 * 1024
          return (size / 1048576).toFixed(currentFixed) + 'M'
        } else if (size < 1099511627776) {  //1024 * 1024 * 1024 * 1024
          return (size / 1073741824).toFixed(currentFixed) + 'G'
        } else if (size < 1125899906842624) {   //1024 * 1024 * 1024 * 1024 * 1024
          return (size / 1099511627776).toFixed(currentFixed) + 'T'
        }
      },
      characterSort: function (array) { //汉字排序
        const newArr = array.sort(function (val1, val2) {
            return val1.name.localeCompare(val2.name, 'zh')
          }
        );
        return this.pySegSort(newArr)
      },
      pySegSort(arr) {
        if (!String.prototype.localeCompare)
          return null;
        let letters = "*abcdefghjklmnopqrstwxyz".split('');
        let zh = "阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀".split('');

        let segs = [];
        let curr;
        letters.forEach(function (item, i) {
          curr = {letter: item.toUpperCase(), data: []};
          arr.forEach(function (item2) {
            if ((!zh[i - 1] || zh[i - 1].localeCompare(item2.name) <= 0) && item2.name.localeCompare(zh[i]) === -1) {
              curr.data.push(item2);
            }
          });
          if (curr.data.length) {
            curr.data.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            });
            segs.push(curr);
          }
        });
        return segs;
      },

      deepClone(data) {
        let type = typeof data;
        let obj;
        if (type === 'array') {
          obj = [];
        } else if (type === 'object') {
          obj = {};
        } else {
          //不再具有下一层次
          return data;
        }
        if (type === 'array') {
          for (let i = 0, len = data.length; i < len; i++) {
            obj.push(this.deepClone(data[i]));
          }
        } else if (type === 'object') {
          for (let key in data) {
            obj[key] = this.deepClone(data[key]);
          }
        }
        return obj;
      },
      mobileCheck: function () {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag
      },

      getOs: function () {
        let ua = navigator.userAgent,
          isWindowsPhone = /(?:Windows Phone)/.test(ua),
          isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
          isAndroid = /(?:Android)/.test(ua),
          isFireFox = /(?:Firefox)/.test(ua),
          // isChrome = /(?:Chrome|CriOS)/.test(ua),
          isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
          isiPhone = /(?:iPhone)/.test(ua) && !isTablet,
          isPc = !isPhone && !isAndroid && !isSymbian,
          isPhone = isiPhone || isAndroid
        return {
          isPhone: isPhone,
          isTablet: isTablet,
          isiPhone: isiPhone,
          isAndroid: isAndroid,
          isPc: isPc
        };
      },
      checkIcon: function (type) {
        let iconClass = ''
        switch (type) {
          case 'js':
            iconClass = 'icon-3-2';
            break;
          case 'txt':
          case 'aspx':
          case 'config':
          case 'cs':
          case 'master':
          case 'asax':
          case 'php':
          case 'jsp':
          case 'asp':
          case 'as':
          case 'rtf':
          case 'h':
          case 'cpp':
            iconClass = 'icon-5-2';
            break;
          case 'html':
          case 'htm':
          case 'xml':
            iconClass = 'icon-5-1';
            break;
          case 'ai':
            iconClass = 'icon-3-1';
            break;
          case 'psd':
            iconClass = 'icon-2-1';
            break;
          case 'png':
          case 'jpg':
          case 'jpge':
          case 'jpeg':
          case 'bmp':
          case 'jif':
          case 'ico':
          case 'tiff':
          case 'eps':
          case 'tif':
          case 'msp':
            iconClass = 'icon-4-2';
            break;
          case 'gif':
            iconClass = 'icon-4-3';
            break;
          case 'asf':
          case 'avi':
          case 'mov':
          case 'rm':
          case 'mp2v':
          case 'mkv':
          case 'mp4':
          case 'mpeg':
          case 'wmv':
          case 'mmm':
          case 'dvd':
          case 'vob':
          case 'mpg':
          case 'rmvb':
            iconClass = 'icon-5-3';
            break;
          case 'ac3':
          case 'aiff':
          case 'au':
          case 'mp3':
          case 'm4a':
          case 'mp2':
          case 'ra':
          case 'wav':
          case 'wpl':
          case 'wma':
            iconClass = 'icon-6-2';
            break;
          case 'doc':
          case 'docx':
            iconClass = 'icon-2-2';
            break;
          case 'ppt':
          case 'pptx':
            iconClass = 'icon-6-4';
            break;
          case 'xls':
          case 'xlsx':
            iconClass = 'icon-4-1';
            break;
          case 'pdf':
            iconClass = 'icon-7-2';
            break;
          case 'rar':
          case '7z':
          case 'zip':
            iconClass = 'icon-1-3';
            break;
          case 'iso':
            iconClass = 'icon-1-4';
            break;
          case 'dwf':
            iconClass = 'icon-3-4';
            break;
          case 'rp':
            iconClass = 'icon-3-3';
            break;
          case 'rvt':
            iconClass = 'icon-6-1';
            break;
          case 'skp':
            iconClass = 'icon-7-4';
            break;
          case 'stl':
            iconClass = 'icon-6-3';
            break;
          case 'swf':
          case 'fle':
            iconClass = 'icon-7-1';
            break;
          case 'vsd':
            iconClass = 'icon-2-3';
            break;
          case 'xmind':
            iconClass = 'icon-7-3';
            break;
          default:
            iconClass = 'icon-1-4';
            break;
        }
        return iconClass
      }

    }
  }
}

export default publicFun
